module.exports = __webpack_public_path__ + "static/media/scale.dbd6304e.svg";